import { useState, useEffect } from 'react'
import styled from 'styled-components'
import { FooterSection, LeadingTitle } from '@components'
import { Table } from 'react-bootstrap'
import { StockAPI, ShortDescriptionAPI, StockCompositionAPI } from '@api'
import './ShareHolder.scss'
import { useTranslation } from 'react-i18next'
import moment from 'moment'

const CorporateContainer = styled.div`
  background-color: #f9f9f9;
  padding-top: 56px;
  overflow: hidden;

  @media screen and (max-width: 767px) {
    padding-top: 0;
  }
`

const ShareHolder = function () {
  const { t } = useTranslation()
  const [informasiSaham, setInformasiSaham] = useState()
  const [komposisiSaham, setKomposisiSaham] = useState()
  const [shortDesc, setShortDesc] = useState(null)

  useEffect(() => {
    const loadInformasiSaham = async () => {
      const { data } = await StockAPI()
      setInformasiSaham(data.data.result)
    }

    const loadKomposisiSaham = async () => {
      const { data } = await StockCompositionAPI()
      setKomposisiSaham(data.data.result)
    }

    const loadData = async () => {
      const { data } = await ShortDescriptionAPI({ loc: 'komposisi_saham' })
      setShortDesc(data.data)
    }

    if (!shortDesc) {
      loadData()
    }

    if (!informasiSaham) {
      loadInformasiSaham()
      loadKomposisiSaham()
    }
  }, [informasiSaham, shortDesc])

  const getMonth = (month) => {
    switch (month) {
      case 'Januari':
        return '01'
      case 'Februari':
        return '02'
      case 'Maret':
        return '03'
      case 'April':
        return '04'
      case 'Mei':
        return '05'
      case 'Juni':
        return '06'
      case 'Juli':
        return '07'
      case 'Agustus':
        return '08'
      case 'September':
        return '09'
      case 'Oktober':
        return '10'
      case 'November':
        return '11'
      case 'Desember':
        return '12'
      default:
        return null
    }
  }

  return (
    <CorporateContainer>
      <LeadingTitle
        title={t('kepemilikan_saham')}
        subtitle={shortDesc !== null ? shortDesc[0].description : ''}
      />

      <div className="kepemilikan-saham-content">
        <ul className="nav nav-underline mb-3" id="pills-tab" role="tablist">
          <li className="nav-item flex-grow-1" role="presentation">
            <button
              className="nav-link w-100 active"
              id="pills-obligasi-tab"
              data-bs-toggle="pill"
              data-bs-target="#pills-obligasi"
              type="button"
              role="tab"
              aria-controls="pills-obligasi"
              aria-selected="true"
            >
              {t('komposisi_saham_pt_bank_bukopin_tbk')}
            </button>
          </li>
          <li className="nav-item flex-grow-1" role="presentation">
            <button
              className="nav-link w-100"
              id="pills-saham-tab"
              data-bs-toggle="pill"
              data-bs-target="#pills-saham"
              type="button"
              role="tab"
              aria-controls="pills-saham"
              aria-selected="false"
            >
              {t('informasi_saham')}
            </button>
          </li>
        </ul>
        <div className="tab-content" id="pills-tabContent">
          <div
            className="tab-pane fade show active"
            id="pills-obligasi"
            role="tabpanel"
            aria-labelledby="pills-obligasi-tab"
          >
            <div className="table-box">
              <Table bordered className="table-striped-custom">
                <thead>
                  <tr className="border-0">
                    <th className="border-0">No.</th>
                    <th className="border-0 text-center">
                      {t('pemegang_saham')}
                    </th>
                    <th className="border-0 text-center">
                      {t('presentasi_saham')} (%)
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {!komposisiSaham
                    ? ''
                    : komposisiSaham.map((data, i) => {
                        return (
                          <tr className="border-0" key={i}>
                            <td className="border-0">{i + 1}</td>
                            <td className="border-0 text-center">
                              {data.pemegang_saham}
                            </td>
                            <td className="border-0 text-center">
                              {data.persentase_saham}
                            </td>
                          </tr>
                        )
                      })}
                </tbody>
              </Table>
            </div>
          </div>
          <div
            className="tab-pane fade"
            id="pills-saham"
            role="tabpanel"
            aria-labelledby="pills-saham-tab"
          >
            <div className="table-box">
              <Table bordered className="table-striped-custom">
                <thead>
                  <tr className="border-0">
                    <th className="border-0">{t('tahun')}</th>
                    <th className="border-0 text-center">{t('bulan')}</th>
                    <th className="border-0 text-center" colSpan="3">
                      {t('harga')}
                    </th>
                    <th className="border-0 text-center">
                      {t('total_saham_diterbitkan')}
                    </th>
                    <th className="border-0 text-center">
                      {t('kapitalisasi_pasar')}
                    </th>
                  </tr>
                  <tr className="border-0">
                    <th className="border-0"></th>
                    <th className="border-0 text-center"></th>
                    <th className="border-0 text-center title-small">
                      {t('tertinggi')}
                    </th>
                    <th className="border-0 text-center title-small">
                      {t('terendah')}
                    </th>
                    <th className="border-0 text-center title-small">
                      {t('penutupan')}
                    </th>
                    <th className="border-0 text-center"></th>
                    <th className="border-0 text-center"></th>
                  </tr>
                </thead>
                <tbody>
                  {!informasiSaham
                    ? ''
                    : informasiSaham.toReversed().map((data, i) => {
                        return (
                          <tr className="border-0" key={i}>
                            <td className="border-0">{data.tahun}</td>
                            <td className="border-0 text-center">
                              {moment(getMonth(data.bulan), 'MM').format(
                                'MMMM'
                              )}
                            </td>
                            <td className="border-0 text-center">
                              {data.harga_tertinggi}
                            </td>
                            <td className="border-0 text-center">
                              {data.harga_terendah}
                            </td>
                            <td className="border-0 text-center">
                              {data.harga_penutupan}
                            </td>
                            <td className="border-0 text-center">
                              {data.total_saham_di_terbitkan}
                            </td>
                            <td className="border-0 text-center">
                              {data.kapitalisai_pasar}
                            </td>
                          </tr>
                        )
                      })}
                </tbody>
              </Table>
            </div>
          </div>
        </div>
      </div>

      <FooterSection currentPage={t('kepemilikan_saham')} />
    </CorporateContainer>
  )
}

export default ShareHolder
